export enum FilterNameButtonEnum {
    EDIT = 0,
    ADD,
    SAVE,
}
